import { z } from 'zod';

export const ClaimInviteSchema = z.object({
    inviterName: z.string().trim().min(1, 'Please enter your name').max(100, 'Please enter a shorter name'),
    inviterEmail: z
        .string()
        .trim()
        .toLowerCase()
        .email('Please enter a valid email')
        .max(254, 'Please enter a valid email'),
    inviteeEmail: z
        .string()
        .trim()
        .toLowerCase()
        .email("Please enter your colleague's email")
        .max(254, "Please enter your colleague's email"),
    message: z.string().trim().max(1000).optional(),
});

export type ClaimInvite = z.infer<typeof ClaimInviteSchema>;
